module.exports = __webpack_public_path__ + "media/4x3/gb-wls-2d554424.svg";